import React from 'react';
import { useTranslation } from 'react-i18next';
import BackButton from '../../../components/buttons/back';

const OrdersNavigation = ({ orders, selected, onSelect }) => {
  const { t } = useTranslation();

  const selectedOrderInd =
    orders && orders.length > 0 ? orders.findIndex((x) => x.id === selected) : -1;

  if (selectedOrderInd === -1) {
    return null;
  }

  const selectedOrder = orders[selectedOrderInd];

  return (
    <div className="flex justify-center items-center mb-5">
      <div className={`${selectedOrderInd === 0 ? 'invisible' : ''}`}>
        <BackButton
          onClick={() => {
            onSelect(orders[selectedOrderInd - 1]);
          }}
        />
      </div>
      <p className="font-primaryMedium text-primary text-base mx-5">
        {t('order.order')} #{selectedOrder.externalNumber || selectedOrder.number}
      </p>
      <div className={`${selectedOrderInd === orders.length - 1 ? 'invisible' : ''}`}>
        <BackButton
          onClick={() => {
            onSelect(orders[selectedOrderInd + 1]);
          }}
          reverse
        />
      </div>
    </div>
  );
};

export default OrdersNavigation;
